module.exports = __webpack_public_path__ + "img/left_menu_yuan_three_hover.e4606903.png";